import React, { FC, useContext, useMemo, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Container from '@mui/material/Container'
import Divider from '@mui/material/Divider'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import {
  validatePostcode,
} from '@kaidam/fc-shared/src/booking/utils'
import BookingContext from '../contexts/booking'
import Loading from '@kaidam/fc-frontend/src/components/system/Loading'
import snackbarActions from '@kaidam/fc-shared/src/frontend/store/modules/snackbar'
import routerActions from '@kaidam/fc-shared/src/frontend/store/modules/router'
import routerSelectors from '@kaidam/fc-shared/src/frontend/store/selectors/router'

const NO_COVERAGE_ERROR = `We don't currently have any surveyor availability in your area, please check back soon.`

const BookingWelcome: FC<React.PropsWithChildren<unknown>> = ({}) => {
  const dispatch = useDispatch()
  const booking = useContext(BookingContext)
  const params = useSelector(routerSelectors.params)

  const html = useMemo(() => {
    return {
      welcome_text: booking.generalConfig.welcome_text ? booking.renderLayout(booking.generalConfig.welcome_text) : '',
    }
  }, [
    booking.generalConfig,
    booking.renderLayout,
  ])

  if(!booking.postcodeInitialised) {
    return (
      <Loading />
    )
  }

  return (
    <Container 
      maxWidth="lg" 
      sx={{
        display: 'flex',
        padding: 2
      }}
    >
      <Paper 
        sx={{
          width: '100%',
          padding: 3
        }}
      >
        {
          booking.coverageETs.length > 0 ? (
            <Button
              variant="outlined"
              color="primary"
              onClick={ () => {
                dispatch(routerActions.navigateTo('booking.product', {
                  orgid: booking.org?.id,
                }))
              } }
            >
              Start Booking
            </Button>
          ) : (
            <Alert severity="error">{ NO_COVERAGE_ERROR }</Alert>
          )
        }
        <Divider sx={{ my: 2 }} />
        {
          html.welcome_text && (
            <Box sx={{ my: 2 }}>
              <div dangerouslySetInnerHTML={{__html: html.welcome_text}}>
              </div>
            </Box>
          )
        }
        <Divider sx={{ my: 2 }} />
        {
          booking.coverageETs.length > 0 ? (
            <Button
              variant="outlined"
              color="primary"
              onClick={ () => {
                dispatch(routerActions.navigateTo('booking.product', {
                  orgid: booking.org?.id,
                }))
              } }
            >
              Start Booking
            </Button>
          ) : (
            <Alert severity="error">{ NO_COVERAGE_ERROR }</Alert>
          )
        }
      </Paper>
    </Container>
  )
}

export default BookingWelcome